angular.module('gym.contacts').controller('AddIntegrapayPaymentDetailsCtrl', ["$scope", "$modalInstance", "loadingAnimation", "flash", "CreditCardValidationService", "gym", "contact", "customer", function($scope, $modalInstance, loadingAnimation, flash, CreditCardValidationService, gym, contact, customer) {
  var base, getDefaultPaymentMethod;
  $scope.gym = gym;
  $scope.contact = contact;
  $scope.customer = customer[0].clone();
  getDefaultPaymentMethod = function() {
    if (gym.credit_card_provider === 'integrapay') {
      return 'credit_card';
    } else {
      return 'bank_account';
    }
  };
  (base = $scope.customer).payment_method || (base.payment_method = getDefaultPaymentMethod());
  $scope.form = {};
  $scope.card = {
    TransparentRedirect: 1
  };
  $scope.bankAccount = {
    rootObjectName: 'payment_method'
  };
  $scope.isTokenLoading = true;
  customer.doPOST({}, 'generate_token').then(function(token) {
    $scope.isTokenLoading = false;
    return $scope.token = token;
  }, function(response) {
    var message;
    message = response.data.error || 'The Worldpay payment system is currently unavailable. Please try again later.';
    flash.error = message;
    return $modalInstance.dismiss();
  });
  $scope.isCreditCard = function() {
    return $scope.customer.payment_method === 'credit_card';
  };
  $scope.isBankAccount = function() {
    return $scope.customer.payment_method === 'bank_account';
  };
  $scope.isFormValid = function() {
    var ref, ref1;
    if ($scope.isTokenLoading) {
      return;
    }
    if ($scope.isCreditCard()) {
      return ((ref = $scope.form.creditCard) != null ? ref.$valid : void 0) && CreditCardValidationService.check($scope.card.CreditCardNumber) && CreditCardValidationService.nameValid($scope.card.CreditCardName);
    } else {
      return (ref1 = $scope.form.bankAccount) != null ? ref1.$valid : void 0;
    }
  };
  $scope.submit = function() {
    $scope.error = '';
    $scope.isLoading = true;
    if ($scope.isCreditCard()) {
      return document.getElementById('card_form').submit();
    } else {
      $scope.bankAccount.form = void 0;
      return customer.doPOST($scope.bankAccount, 'update_bank_account').then(function(data) {
        var bankAccountName;
        bankAccountName = (gym.country === 'US' && 'Checking Account') || 'Bank Account';
        flash.success = `${bankAccountName} details saved successfully.`;
        return $modalInstance.close();
      }, function(response) {
        $scope.isLoading = false;
        return $scope.error = 'An error occurred saving bank account details. Please try again later.';
      });
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
